import * as Progress from '@radix-ui/react-progress';

import { useToastProgress } from './useToastProgress';

const ToastProgress = (props: Parameters<typeof useToastProgress>[0]) => {
  const progress = useToastProgress(props);

  if (!props.shouldShowProgress) return null;

  return (
    <Progress.Root value={progress} max={100} className="absolute bottom-0 left-0 right-0 h-1 bg-gray-200 overflow-hidden">
      <Progress.Indicator
        className="h-full bg-text-primary rounded-r-full transition-all duration-50 ease-linear"
        style={{ width: `${progress}%` }}
      />
    </Progress.Root>
  );
};

export default ToastProgress;
